import { render } from "./NoAuth.vue?vue&type=template&id=80b1df86"
import script from "./NoAuth.vue?vue&type=script&lang=js"
export * from "./NoAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__